export default __webpack_public_path__ + "static/media/three.03c42592.png";